<!-- Comment section start -->
<div class="kt-separator kt-separator--space-lg kt-separator--border-dashed my-3">
</div>
<!-- Comment section end -->

<!-- Write Comments start -->
<div class="d-flex" style="position: relative;" *ngIf="activeTab === handoverNoteType.Active">
  <ng-container *ngxPermissionsOnly="PermissionV2.HANDOVER_NOTES_COMMENT_MANAGE">
    <div class="comment-box flex-fill">
      <form [formGroup]="commentForm" (ngSubmit)="addCommentHandler()">
        <div #msgInput contenteditable="true" (input)="commentInputHandler($event)" class="form-control height-auto"
          (paste)="pasteHandler($event)">
        </div>
        <span #icons class="symbol">
          <svg-icon class="svg_icon17x17 brand-config-color d-inline pointer me-2" (click)="toggleEmojis()" src="assets/media/iq-svg/without_circle/icon_set_3/emoji.svg"></svg-icon>
          <svg-icon class="svg_icon17x17 brand-config-color d-inline pointer" (click)="fileUploader.click()" src="assets/media/iq-svg/without_circle/icon_set_3/gallery.svg"></svg-icon>
        </span>
      </form>
    </div>

    <div [ktAppendToElement]="icons" *ngIf="showEmojis()" (click)="$event.stopPropagation()" role="textarea">
      <emoji-mart class="emoji-mart" emoji="point_up" [sheetSize]="32" (emojiSelect)="addEmoji($event)" title="Pick your emoji…">
      </emoji-mart>
    </div>

    <div class="icon-container">
      <!-- <kt-button [buttonConfig]="postButtonConfigRef" (buttonClick)="addCommentHandler()"></kt-button> -->
      <button class="btn btn-secondary btn-icon kt-ml-10" (click)="addCommentHandler()">

        <svg-icon class="svg_icon17x17 brand-config-color " src="assets/media/iq-svg/without_circle/icon_set_3/send_message.svg"></svg-icon>
      </button>
      <button class="btn btn-secondary btn-icon kt-ml-10" *ngIf="this.editComment" (click)="clearCommentClickHandler()">
        <svg-icon class="svg_icon17x17" src="assets/media/iq-svg/without_circle/icon_set_3/close.svg"></svg-icon>
      </button>
    </div>
  </ng-container>
</div>
<div
  *ngIf="!commentForm.get('hand_over_note_comment_text')?.value && commentForm.get('hand_over_note_comment_upload_1').value"
  class="text-danger">Please Enter The Comment</div>
<!-- Upload image -->
<ng-template #popContent>
  <div class="comment-image-upload mb-3">

    <img width="100" height="100"
      *ngIf="commentForm?.value?.hand_over_note_comment_upload_1?.toLowerCase()?.includes('jpeg') || commentForm?.value?.hand_over_note_comment_upload_1?.toLowerCase()?.includes('jpg') || commentForm?.value?.hand_over_note_comment_upload_1?.toLowerCase()?.includes('png')"
      src="{{commentForm?.value?.hand_over_note_comment_upload_1 }}" alt="image" />
    <img width="100" height="100" style="object-fit: contain;"
      *ngIf="commentForm?.value?.hand_over_note_comment_upload_1?.toLowerCase()?.includes('pdf')"
      src="../../../../../assets/media/bg/pdf.png" alt="image" />
    <img width="100" height="100" style="object-fit: contain;"
      *ngIf="commentForm?.value?.hand_over_note_comment_upload_1?.toLowerCase()?.includes('mp4') || commentForm?.value?.hand_over_note_comment_upload_1?.toLowerCase()?.includes('webm')"
      src="../../../../../assets/media/bg/video.jpg" alt="image" />
    <img width="100" height="100" style="object-fit: contain;"
      *ngIf="commentForm?.value?.hand_over_note_comment_upload_1?.toLowerCase()?.includes('mp3')"
      src="../../../../../assets/media/bg/audio.png" alt="image" />
    <button type="button" class="btn btn-delete btn-icon" (click)="deleteUploadedFileHandler()">
      <svg-icon class="svg_icon13x13" src="assets/media/iq-svg/without_circle/icon_set_3/delete.svg"></svg-icon>
    </button>
  </div>
</ng-template>

<ng-template *ngIf="showPopover" [ngTemplateOutlet]="popContent"></ng-template>

<input #fileUploader type="file" style="display: none;" [accept]="allowedExtensions" (change)="fileChange($event)">
<!-- Write Comments end -->
<ng-container *ngxPermissionsOnly="PermissionV2.HANDOVER_NOTES_COMMENT_ACCESS">
<div class="kt-notes mt-3">
  <ngb-accordion #acc="ngbAccordion" (shown)="showPanel($event)" (panelChange)="showPanel($event)">
    <ngb-panel [disabled]="!commentCount">
      <ng-template ngbPanelHeader>
        <div class="d-flex align-items-center justify-content-between">
          <button [disabled]="!commentCount" ngbPanelToggle class="btn btn-link container-fluid text-start">
            {{ commentCount || 'No' }} Comments
          </button>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <ng-container *ngIf="commentCount">
          <div class="kt-notes__items">
            <div class="kt-notes__item" *ngFor="let comment of commentDataById">
              <div class=" kt-notes__media">
                <div class="kt-media kt-media--circle circle-sm">
                  <img *ngIf="comment?.user_business?.user_business_profile_image_url"
                    src="{{comment?.user_business?.user_business_profile_image_url}}" alt="image">
                </div>
                <div *ngIf="!comment?.user_business?.user_business_profile_image_url"
                  class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-badge--username ">
                  {{(comment?.user_business?.user_business_first_name + ' ' +
                  comment?.user_business?.user_business_last_name ) | firstLetter}}
                </div>
              </div>
              <div class="kt-notes__content">
                <div class="kt-notes__section">
                  <div class="kt-notes__info">
                    <span class="kt-notes__title text-dark">
                      {{comment?.user_business?.user_business_first_name + ' ' +
                      comment?.user_business?.user_business_last_name }}
                      <small *ngIf="comment?.user_business?.user_business_archive">(Archived)</small>
                    </span>
                    <span class="kt-notes__desc">
                      {{(comment?.hand_over_note_comment_modified_at || comment?.hand_over_note_comment_created_at) |
                      TimeFromNow}}
                      <span *ngIf="comment?.hand_over_note_comment_is_edited">[Edited]</span>
                    </span>
                  </div>
                  <div class="kt-notes__dropdown">
                    <ng-container *ngxPermissionsOnly="PermissionV2.HANDOVER_NOTES_COMMENT_MANAGE">
                      <button (click)="editCommentClickHandler(comment)" type="button"
                        *ngIf="(activeTab === handoverNoteType.Active) && !(this.editComment && this.editComment?.hand_over_note_comment_id == comment.hand_over_note_comment_id) && ((this.userInfo && (comment?.hand_over_note_comment_fk_user_id === this.userInfo.user_id)))"
                        class="btn btn-sm btn-clean btn-icon btn-icon-sm brand-config-color-hover">
                        <svg-icon src="assets/media/iq-svg/without_circle/icon_set_3/edit.svg"></svg-icon>
                      </button>
                    </ng-container>
                    <button (click)="clearCommentClickHandler()"
                      *ngIf="(activeTab === handoverNoteType.Active) && this.editComment && this.editComment?.hand_over_note_comment_id == comment.hand_over_note_comment_id"
                      type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                      <svg-icon class="svg_icon17x17" src="assets/media/iq-svg/without_circle/icon_set_3/close.svg"></svg-icon>
                    </button>

                    <ng-container *ngxPermissionsOnly="PermissionV2.HANDOVER_NOTES_COMMENT_MANAGE">
                      <ng-container *ngIf="(activeTab === handoverNoteType.Active)">
                        <button (click)="deleteCommentConfirmation(comment)"
                          *ngIf="(this.userInfo && comment?.hand_over_note_comment_fk_user_id === this.userInfo.user_id) ||  (loginUserProfile === roleRef.System_Administrator)"
                          type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm brand-config-color-hover">
                          <svg-icon src="assets/media/iq-svg/without_circle/icon_set_3/delete.svg"></svg-icon>
                        </button>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
                <a *ngIf="comment.hand_over_note_comment_upload_1" href="javascript:void(0)"
                  class="comment-media  mr-10"
                  (click)="commentFileViewerHandler(comment.hand_over_note_comment_upload_1)"
                  style="margin-right: 2rem;">
                  <img
                    *ngIf="comment.hand_over_note_comment_upload_1?.toLowerCase()?.includes('jpeg')|| comment.hand_over_note_comment_upload_1?.toLowerCase()?.includes('jpg') || comment.hand_over_note_comment_upload_1?.toLowerCase()?.includes('png')"
                    src="{{comment.hand_over_note_comment_upload_1 }}" alt="image" class="mb-4" />
                  <img style="object-fit: contain;" *ngIf="comment.hand_over_note_comment_upload_1?.toLowerCase()?.includes('pdf')"
                    src="../../../../../assets/media/bg/pdf.png" alt="image" class="mb-4" />
                  <img style="object-fit: contain;"
                    *ngIf="comment.hand_over_note_comment_upload_1?.toLowerCase()?.includes('mp4') || comment.hand_over_note_comment_upload_1?.toLowerCase()?.includes('webm')"
                    src="../../../../../assets/media/bg/video.jpg" alt="image" class="mb-4" />
                  <img style="object-fit: contain;" *ngIf="comment.hand_over_note_comment_upload_1?.toLowerCase()?.includes('mp3')"
                    src="../../../../../assets/media/bg/audio.png" alt="image" class="mb-4" />
                </a>
                <span class="kt-notes__body ql-editor-preview"
                  [innerHTML]="comment?.hand_over_note_comment_text | safe: 'html'">
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
</ng-container>
